/* eslint-disable no-unused-vars */
import {
    DETAILS_INPUT,
    DETAILS_LOADING,
    FETCH_ORDERS_DATA,
    FETCH_ORDERS_SUMMARY,
    FETCH_ORDER_DETAILS,
    FETCH_ORDER_NOTES,
    LIST_LOADING,
    ORDER_NOTE_INPUT,
    ORDER_NOTE_STATUS_MSG,
    SET_SELECTED_DATA,
    SET_SINGLE_ORDER_DATA,
    UPDATE_ORDER_DETAILS,
    NOTES_LOADING,
    NEW_ORDER_NOTE,
    ORDER_TRACKING_INPUT,
    ORDER_TRACKING_INPUT_RESET,
} from './ordersActionTypes';

const ordersInitialState = {
    ordersData: [],
    selectedRowKeys: [],
    ordersSummary: {},
    orderDetails: {},
    orderNotes: [],
    orderStatus: [
        { name: 'Pending', value: 'pending' },
        { name: 'Processing', value: 'processing' },
        { name: 'On-Hold', value: 'on-hold' },
        { name: 'Completed', value: 'completed' },
        { name: 'Cancelled', value: 'cancelled' },
        { name: 'Refunded', value: 'refunded' },
        { name: 'Failed', value: 'failed' },
    ],
    ordersTotalPages: 0,
    singleOrderDetails: {},
    listLoading: false,
    detailsLoading: false,
    noteLoader: false,
    newCustomerNote: {
        note: '',
        status: '',
        customer_note: 'customer_note',
    },
    orderNoteStatus: {
        status: '',
        message: '',
    },
    orderTrackingNo: {
        provider: '',
        number: '',
        date: '',
    },
};

const ordersReducer = (state = ordersInitialState, { type, payload, ordersTotalPages }) => {
    switch (type) {
        // Get Order Data (Initial, filtered, Mutated)
        case FETCH_ORDERS_DATA:
            return {
                ...state,
                ordersData: payload,
                ordersTotalPages,
            };
        // Get Order Summery
        case FETCH_ORDERS_SUMMARY:
            return {
                ...state,
                ordersSummary: payload,
            };
        // Get Single Product
        case FETCH_ORDER_DETAILS:
            return {
                ...state,
                orderDetails: payload,
            };
        case SET_SELECTED_DATA:
            return {
                ...state,
                selectedRowKeys: payload,
            };
        case SET_SINGLE_ORDER_DATA:
            return {
                ...state,
                singleOrderDetails: payload,
            };
        case LIST_LOADING:
            return {
                ...state,
                listLoading: payload,
            };
        case DETAILS_LOADING:
            return {
                ...state,
                detailsLoading: payload,
            };
        case DETAILS_INPUT:
            return {
                ...state,
                singleOrderDetails: {
                    ...state.singleOrderDetails,
                    [payload.name]: payload.value,
                },
            };
        case UPDATE_ORDER_DETAILS:
            return {
                ...state,
                singleOrderDetails: { ...payload },
            };
        case FETCH_ORDER_NOTES:
            return {
                ...state,
                orderNotes: payload,
            };
        case ORDER_NOTE_INPUT:
            return {
                ...state,
                newCustomerNote: {
                    ...state.newCustomerNote,
                    [payload.name]: payload.value,
                    status: payload.status,
                },
            };
        case NEW_ORDER_NOTE:
            return {
                ...state,
                newCustomerNote: {
                    note: '',
                    status: '',
                    customer_note: 'customer_note',
                },
            };
        case ORDER_NOTE_STATUS_MSG:
            return {
                ...state,
                orderNoteStatus: { ...payload },
            };
        case NOTES_LOADING:
            return {
                ...state,
                noteLoader: payload,
            };
        case ORDER_TRACKING_INPUT:
            return {
                ...state,
                orderTrackingNo: {
                    ...state.orderTrackingNo,
                    [payload.name]: payload.value,
                },
            };
        case ORDER_TRACKING_INPUT_RESET:
            return {
                ...state,
                orderTrackingNo: {
                    ...payload,
                },
            };
        default:
            return state;
    }
};

export default ordersReducer;
